<template>
    <page>
        <module>
            <div class="guide-detail">
                <!-- 标题 -->
                <h1 class="guide-title">{{ name }}</h1>
                <!-- 发布时间> -->
                <p class="guide-time">发布时间：{{ create_date }}</p>
                <!-- 横向分割线 -->
                <div class="guide-line"></div>
                <!-- 视频区域（如果有视频） -->
                <video v-if="video_url" class="guide-video" :src="video_url" preload="auto" autoplay="true" controls="true" webkit-playsinline playsinline x-webkit-airplay="allow" x5-video-player-type="h5"></video>
                <!-- 文章内容 -->
                <div class="guide-content" v-html="content"></div>
            </div>
        </module>
    </page>
</template>

<script>
export default {
    name: 'hellp_detail',

    props: {
        id: String
    },

    data() {
        return {
            name: '',//标题
            img_url: '',//封面图
            video_url: '',//视频
            content: '',// 内容
            create_date: ''
        }
    },

    computed: {

    },

    watch: {
        id() {
            this.getDetail();
        },
    },

    mounted() {
        if (this.id) {
            this.getDetail();
        }
    },

    methods: {
        getDetail() {
            this.request({
                url: '/abstract_consultation/detail',
                data: {
                    id: this.id
                },
                loading: true,
                success: data => {
                    this.name=data.name;
                    this.img_url=data.img_url;
                    this.video_url=data.video_url;
                    this.content=data.content;
                    this.create_date=data.create_date;
                }
            });
        }
    }
}
</script>

<style scoped>
    .guide-detail {
        padding: 50px;
        max-width: 1000px;
        margin: 0 auto;
    }

    .guide-title {
        text-align: center;
        margin-bottom: 30px;
        color: #333;
        font-size: 28px;
        font-weight: bold;
    }
    .guide-time {
        line-height: 28px;
        text-align: left;
        color: #999;
        font-size: 12px;
    }
    .guide-line {
        width: 100%;
        height: 1px;
        background-color: #ddd;
    }

    .guide-video {
        width: 100%;
        height: 600px;
        margin-top: 30px;
        text-align: center;
        background: #000;
    }

    .guide-content {
        line-height: 1.8;
        color: #555;
        font-size: 16px;
        padding-top: 30px;
        word-break: break-word;
        word-wrap: break-word;
    }
</style>
